import { call } from './utils';

export const createDeleteRequests = async (data, accessToken) =>
  await call({
    url: '/api/delete-requests/create',
    data: { data },
    token: accessToken
  });
export const removeDeleteRequests = async (data, accessToken) =>
  await call({
    url: '/api/delete-requests/remove',
    data: { data },
    token: accessToken
  });
export const findAllDeleteRequests = async (data, accessToken) =>
  await call({
    url: '/api/delete-requests/find/all',
    method: 'GET',
    token: accessToken
  });
